import type { TeamMember, TeamRole } from '@/types'

export const WORKSPACE = {
    name: 'Arunika',
    slug: 'arunika',
    seats: 10
}

export const CURRENT_USER = {
    name: 'Raka Pratama',
    email: 'raka@arunika.id',
    title: 'Pendiri dan CEO',
    phone: '0812 3456 7890'
}

export const TEAM_MEMBERS: TeamMember[] = [
    { id: 'tm-01', name: 'Raka Pratama', email: 'raka@arunika.id', title: 'Pendiri dan CEO', role: 'owner', status: 'active', lastActiveAt: '2026-11-03', invitedAt: null },
    { id: 'tm-02', name: 'Sinta Maharani', email: 'sinta@arunika.id', title: 'Kepala Operasional', role: 'admin', status: 'active', lastActiveAt: '2026-11-03', invitedAt: null },
    { id: 'tm-03', name: 'Bayu Firmansyah', email: 'bayu@arunika.id', title: 'Kepala Teknologi', role: 'admin', status: 'active', lastActiveAt: '2026-11-02', invitedAt: null },
    { id: 'tm-04', name: 'Nadia Halim', email: 'nadia@arunika.id', title: 'Manajer Keuangan', role: 'finance', status: 'active', lastActiveAt: '2026-10-31', invitedAt: null },
    { id: 'tm-05', name: 'Laras Kusuma', email: 'laras@arunika.id', title: 'Customer Success', role: 'support', status: 'active', lastActiveAt: '2026-11-03', invitedAt: null },
    { id: 'tm-06', name: 'Galih Permana', email: 'galih@arunika.id', title: 'Analis Data', role: 'viewer', status: 'active', lastActiveAt: '2026-10-29', invitedAt: null },
    { id: 'tm-07', name: 'Reza Hakim', email: 'reza@arunika.id', title: 'Dukungan Pelanggan', role: 'support', status: 'invited', lastActiveAt: null, invitedAt: '2026-11-01' }
]

export const PERMISSIONS: { label: string, roles: TeamRole[] }[] = [
    { label: 'Melihat dashboard dan laporan', roles: ['owner', 'admin', 'finance', 'support', 'viewer'] },
    { label: 'Mengelola data pelanggan', roles: ['owner', 'admin', 'support'] },
    { label: 'Mengelola paket dan tagihan', roles: ['owner', 'admin', 'finance'] },
    { label: 'Mengekspor data', roles: ['owner', 'admin', 'finance'] },
    { label: 'Mengundang dan mengatur tim', roles: ['owner', 'admin'] },
    { label: 'Mengubah pengaturan workspace', roles: ['owner', 'admin'] },
    { label: 'Mengelola penagihan Arunika', roles: ['owner'] }
]

export const ASSIGNABLE_ROLES: TeamRole[] = ['admin', 'finance', 'support', 'viewer']
